import { Fragment } from "react/jsx-runtime";
import { t } from "ttag";

import type { Summary } from "@/features/products/models";
import { Card } from "@/shared/ui";

interface TotalSummaryProps {
  summary: Summary;
}

export const TotalSummary = ({ summary }: TotalSummaryProps) => {
  return (
    <Card.Root className="rounded-lg border px-3 py-4">
      <Card.Content className="grid grid-cols-[1fr_auto] place-content-between gap-y-1.5">
        <div className="col-span-2 grid grid-cols-[1fr_auto] place-content-between gap-y-2">
          <Card.Description className="text-xs text-secondary-900">
            {t`Subtotal`}
          </Card.Description>
          <Card.Description className="text-end text-xs text-secondary-900">
            {summary.subtotal}
          </Card.Description>

          {summary.items.map(({ label, amount }) => (
            <Fragment key={label}>
              <Card.Description className="text-xs text-secondary-900">
                {label}
              </Card.Description>
              <Card.Description className="text-end text-xs text-secondary-900">
                {amount}
              </Card.Description>
            </Fragment>
          ))}
        </div>

        <Card.Description className="self-center font-medium text-secondary-950">
          {t`Total`}
        </Card.Description>
        <Card.Description className="text-end text-base leading-7 font-semibold">
          {summary.total}
        </Card.Description>
      </Card.Content>
    </Card.Root>
  );
};
